import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import moment from 'moment';

export const EARNINGS_KEY_PREFIX = ['earnings'];
export const earningsKey = (campaignID, year) => [...EARNINGS_KEY_PREFIX, campaignID, year];

const useEarnings = (campaignID, year) => {
    const isCurrentYear = year === moment().year();
    const endPoint = `/Statistics/Earnings${campaignID > 0 ? `/${campaignID}` : ''}`;
    const params =campaignID > 0 ? {Year: year, CampaignID: campaignID} : {Year: year}
    
    return useQuery(
        earningsKey(campaignID, year),
        () => apiClient.get(endPoint, { params:params }).then(r => r.data),
        { staleTime: isCurrentYear ? 5 * 60 * 1000 : Infinity }
    );
};

export default useEarnings;
